module.exports = __webpack_public_path__ + "img/element-left.5e982984.png";